module.exports = __webpack_public_path__ + "img/feather.522a7b23.png";